import { Md5 } from 'ts-md5'

/**
 * Repr�sente une requ�te
 */
export class RequeteModel {
    Url: string;
    Date: Date;

    /**
     * Constructeur
     * @param url URL de la requ�te
     */
    constructor(url: string) {
        this.Url = url;
        this.Date = new Date();
    }

    /**
     * Calcul le HASH de cet objet
     */
    get Hash(): string {
        return new Md5().appendStr(this.Url).end().toString();
    }
}
